import { ListBase } from 'react-admin';
import { FormationListLayout } from './FormationListLayout';

export const FormationList = () => {
    return (
        <ListBase
            resource="formation"
            perPage={25}
            sort={{ field: 'name', order: 'ASC' }}
        >
            <FormationListLayout />
        </ListBase>
    );
};
